import service from "@/store/services/property-fees-service";

export const state = () => ({
  list: {},
  propertyFee: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, propertyFee) => {
    state.propertyFee = propertyFee;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((propertyFee) => {
      commit("SET_RESOURCE", propertyFee);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((propertyFee) => {
      commit("SET_RESOURCE", propertyFee);
    });
  },

  applyFee({ commit, dispatch }, params) {
    return service.applyFee(params, this.$axios).then((propertyFee) => {
      commit("SET_RESOURCE", propertyFee);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((propertyFee) => {
      commit("SET_RESOURCE", propertyFee);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  propertyFee: (state) => state.propertyFee,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((propertyFee) => ({
      id: propertyFee.id,
    }));
  },
};

const propertyFees = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default propertyFees;
